module.exports = __webpack_public_path__ + "static/media/caret-square-right.29bdd2d7.svg";